import * as THREE from "three";

export const zoomTo = (camera, objects) => {
  camera.controls.rotateTo(0, Math.PI * 0.1, true);
  const box = new THREE.Box3();
  // const group = new THREE.Group();
  objects.forEach((o) => {
    box.expandByObject(o);
  });
  camera.controls.fitToBox(box, true, { paddingLeft: 10, paddingRight: 10, paddingBottom: 10, paddingTop: 10 });
};

const DEG90 = Math.PI * 0.5;
const DEG180 = Math.PI;

export const rotateTo = (camera, side) => {
  switch (side) {
    case "Front":
      camera.controls.rotateTo(0, DEG90, true);
      break;

    case "Back":
      camera.controls.rotateTo(DEG180, DEG90, true);
      break;

    case "Top":
      camera.controls.rotateTo(0, 0, true);
      break;

    case "Bottom":
      camera.controls.rotateTo(0, DEG180, true);
      break;

    case "Right":
      camera.controls.rotateTo(DEG90, DEG90, true);
      break;

    case "Left":
      camera.controls.rotateTo(-DEG90, DEG90, true);
      break;
    default:
      break;
  }
};
